/* Glocal Depot global JS (v2)
   ─────────────────────────────────────────────
   変更点:
   - すべての初期化を gdInit() にまとめ、Shopify テーマエディタの
     shopify:section:load / :unload / :select でも再初期化されるようにした。
     （従来はカスタマイザでセクションを編集するとドロップダウン等が動かなくなっていた）
   - ドロップダウンに aria-expanded とキーボード操作（Esc / 矢印）を追加。
   - モバイルドロワーの開閉、フォーカストラップ、国セレクタの自動送信を追加。
   - Back to top を theme.liquid のインラインscriptから移設。
   - prefers-reduced-motion を尊重。
*/
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    var els = scope.querySelectorAll('.gd-reveal:not(.gd-on)');
    if (!els.length) return;
    if (REDUCE || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gd-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gd-on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- カテゴリバーのドロップダウン ---------- */
  function closeAllDropdowns(except) {
    document.querySelectorAll('.gd-dd.gd-dd-open').forEach(function (dd) {
      if (dd === except) return;
      dd.classList.remove('gd-dd-open');
      var b = dd.querySelector('.gd-dd-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function initDropdowns(scope) {
    scope.querySelectorAll('.gd-dd').forEach(function (dd) {
      var btn = dd.querySelector('.gd-dd-btn');
      if (!btn || btn.dataset.gdBound) return;
      btn.dataset.gdBound = '1';

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !dd.classList.contains('gd-dd-open');
        closeAllDropdowns(dd);
        dd.classList.toggle('gd-dd-open', willOpen);
        btn.setAttribute('aria-expanded', String(willOpen));
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          dd.classList.add('gd-dd-open');
          btn.setAttribute('aria-expanded', 'true');
          var first = dd.querySelector('.gd-dd-menu a');
          if (first) first.focus();
        }
      });

      dd.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!dd.contains(document.activeElement)) {
            dd.classList.remove('gd-dd-open');
            btn.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });
  }

  /* ---------- モバイルドロワー ---------- */
  function initDrawer() {
    var toggle = document.getElementById('gd-nav-toggle');
    var drawer = document.getElementById('gd-mobile-drawer');
    if (!toggle || !drawer || toggle.dataset.gdBound) return;
    toggle.dataset.gdBound = '1';

    var panel = drawer.querySelector('.gd-drawer-panel');
    var overlay = drawer.querySelector('.gd-drawer-overlay');
    var closeBtn = drawer.querySelector('.gd-drawer-close');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('gd-no-scroll');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('gd-no-scroll');
      var done = function () { drawer.hidden = true; };
      if (REDUCE) done(); else setTimeout(done, 220);
      if (lastFocus) lastFocus.focus();
    }

    toggle.addEventListener('click', function () {
      drawer.hidden ? open() : close();
    });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab' || !panel) return;
      var focusables = panel.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- 国／通貨セレクタ ---------- */
  function initLocalization(scope) {
    scope.querySelectorAll('.gd-country-select').forEach(function (sel) {
      if (sel.dataset.gdBound) return;
      sel.dataset.gdBound = '1';
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------- ヘッダー高さを CSS 変数へ ---------- */
  function updateHeaderHeight() {
    var nav = document.querySelector('.gd-nav') || document.querySelector('body > nav');
    var catbar = document.querySelector('.gd-catbar');
    if (!nav) return;
    document.documentElement.style.setProperty('--gd-nav-h', nav.offsetHeight + 'px');
    if (catbar) document.documentElement.style.setProperty('--gd-catbar-h', catbar.offsetHeight + 'px');
  }

  /* ---------- カテゴリバーのスクロール制御 ---------- */
  function initCatbarScroll() {
    var catbar = document.querySelector('.gd-catbar');
    if (!catbar || catbar.dataset.gdBound) return;
    catbar.dataset.gdBound = '1';
    function handle() {
      if (window.innerWidth > 860) { catbar.classList.remove('gd-catbar-hide'); return; }
      catbar.classList.toggle('gd-catbar-hide', window.scrollY > 0);
    }
    window.addEventListener('scroll', handle, { passive: true });
    handle();
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var btn = document.getElementById('gd-back-to-top');
    if (!btn || btn.dataset.gdBound) return;
    btn.dataset.gdBound = '1';
    function toggle() { btn.classList.toggle('is-visible', window.scrollY > 500); }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: REDUCE ? 'auto' : 'smooth' });
    });
  }

  /* ---------- 言語メニューの開閉（Shopify 純正フォーム） ---------- */
  function initLanguageMenu(scope) {
    scope.querySelectorAll('.gd-language').forEach(function (wrap) {
      var btn = wrap.querySelector('.gd-language-btn');
      if (!btn || btn.dataset.gdBound) return;
      btn.dataset.gdBound = '1';

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });

      wrap.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!wrap.contains(document.activeElement)) {
            wrap.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });
  }

  function closeLanguageMenus() {
    document.querySelectorAll('.gd-language.is-open').forEach(function (w) {
      w.classList.remove('is-open');
      var b = w.querySelector('.gd-language-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- ヒーロー背景動画 ----------
     <template> から必要なときだけ挿入する。
     ・モバイルで再生しない設定なら、その幅では一切読み込まない
     ・prefers-reduced-motion が有効なら再生しない（ポスター画像のまま）
     ・リサイズでデスクトップ幅になったら後から挿入する
  */
  function initHeroVideo() {
    var host = document.getElementById('gd-hero-video');
    var tpl = document.getElementById('gd-hero-video-tpl');
    if (!host || !tpl || host.dataset.gdBound) return;
    host.dataset.gdBound = '1';

    if (REDUCE) return;

    var allowMobile = host.dataset.mobileVideo === 'true';
    var bp = parseInt(host.dataset.breakpoint, 10) || 861;

    function shouldLoad() {
      return allowMobile || window.innerWidth >= bp;
    }

    function mount() {
      if (host.childElementCount) return;
      host.appendChild(tpl.content.cloneNode(true));
      var v = host.querySelector('video');
      if (v && v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      host.classList.add('is-loaded');
    }

    if (shouldLoad()) {
      mount();
      return;
    }

    var onResize = function () {
      if (!shouldLoad()) return;
      mount();
      window.removeEventListener('resize', onResize);
    };
    window.addEventListener('resize', onResize);
  }

  /* ---------- 初期化 ---------- */
  function gdInit(scope) {
    scope = scope || document;
    initReveal(scope);
    initDropdowns(scope);
    initLocalization(scope);
    initLanguageMenu(scope);
    initDrawer();
    initCatbarScroll();
    initBackToTop();
    initHeroVideo();
    updateHeaderHeight();
  }

  document.addEventListener('click', function () { closeAllDropdowns(); closeLanguageMenus(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllDropdowns(); closeLanguageMenus(); }
  });

  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('load', updateHeaderHeight);
  setTimeout(updateHeaderHeight, 300);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateHeaderHeight);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { gdInit(document); });
  } else {
    gdInit(document);
  }

  /* テーマエディタ対応 */
  document.addEventListener('shopify:section:load', function (e) { gdInit(e.target); });
  document.addEventListener('shopify:section:unload', updateHeaderHeight);
  document.addEventListener('shopify:section:select', function (e) { gdInit(e.target); });

  window.gdInit = gdInit;
})();
